import $ from "jquery";

const accordionSelector = ".component-accordion-element";

class Accordion {

    constructor(element) {
        this.element = element;
        this.$element = $(element);

        this.panel = this.$element.find(`${accordionSelector}__inner-blocks`).first()[0];

        this.isOpen = this.$element.hasClass("open");

        this.attachEvents();
    }

    attachEvents() {
        this.$element.find(`${accordionSelector}__title`).click(() => {
            this.toggle();
        })
    }

    toggle() {
        if(this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    open() {
        this.$element.addClass("open");
        // this.panel.style.maxHeight = this.panel.scrollHeight + "px";
        this.isOpen = true;
    }

    close() {
        this.$element.removeClass("open");
        // this.panel.style.maxHeight = "0px";
        this.isOpen = false;
    }

}

$('.information-container').each(function(index){
    $(this).attr('id', 'company-' + (index + 1));
    $(this).find('.button-modal').attr("data-target",'#modal-company-' + (index + 1));
    $(this).next('.company-modal').attr("id",'modal-company-' + (index + 1)).attr("aria-labelledby",'modal-company-' + (index + 1));
    $(this).next('.company-modal').find("h5").attr("id","modal-label-"+ (index + 1));
});

export default function() {
    $(accordionSelector).each(function() {
        new Accordion(this);
    });
}


